import { Fragment, useContext, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import dayjs from 'dayjs'
import styled from 'styled-components'

import { toast } from '../../utils'

import { StoresContext } from '../../provider/StoreProvider'

import { ColumnItem } from '../../components/common'
import { Text } from '../../components/text'
import { DivideLine } from '../../components/divide'
import { PagingContent } from '../../components/pagingList'
import { EmptyPage } from '../../components/exception/EmptyPage'

export const MainNotification: React.FC = observer(() => {
  const { authStore, notificationStore } = useContext(StoresContext)
  const pagingStore = notificationStore.notificationPagingStore

  useEffect(() => {
    if (!authStore.userInfo) return
    try {
      loadData()
    } catch (error) {
      toast('페이지를 불러오는데 실패했습니다.', error, false)
    }
  }, [])

  const loadData = async () => {
    await pagingStore.load(undefined, true)
    await notificationStore.readAllNotification()
  }

  if (!authStore.userInfo) {
    return <EmptyPage />
  }

  return (
    <PagingContent pagingStore={pagingStore}>
      {pagingStore.list.map(({ id, title, contents, createdDate }) => (
        <Fragment key={id}>
          <ContentContainer>
            <Text size={14} weight={600} color="text_secondary">
              {title}
            </Text>
            <Text size={16} weight={500}>
              {contents}
            </Text>
            <Text size={12} color="text_secondary">
              {dayjs(new Date(createdDate)).format('YYYY.MM.DD')}
            </Text>
          </ContentContainer>
          <DivideLine />
        </Fragment>
      ))}
    </PagingContent>
  )
})

const ContentContainer = styled(ColumnItem)`
  gap: 6px;
  padding: 16px 24px;
  > *:last-child {
    margin-top: 2px;
  }
`
